import { render, staticRenderFns } from "./hotel-feature-list.vue?vue&type=template&id=03d1ccf2"
import script from "./hotel-feature-list.vue?vue&type=script&lang=ts"
export * from "./hotel-feature-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports